import { useRef } from 'react'
import { comparisonOperatorConfigs, Operator } from '@global/constants/comparisonOperators'
import { User } from '@global/types'
import { DbColumnName } from '../../readGridToolbar/components/toggleColumns/types'
import { UserOptions } from '../types'
import { SelectMultipleUsers } from './selectMultipleUsers'
import { SelectSingleUser } from './selectSingleUser'

interface Props {
  filterIndex: number
  filterValue: User | User[]
  name: DbColumnName
  operator: Operator
  userOptions: UserOptions
  onChange: (idx: number) => (obj: { target: { value: (string | User)[] | User | string } }) => void
}

export const SelectUser = ({
  filterIndex,
  filterValue,
  name,
  operator,
  userOptions,
  onChange,
}: Props) => {
  const { createdBy, updatedBy } = userOptions
  const options = name === 'properties.createdById' ? createdBy : updatedBy || []
  const operatorConfig = comparisonOperatorConfigs[operator]
  const canHaveMultipleValues = Boolean(operatorConfig?.canHaveMultipleValues())

  const userMap = useRef(new Map(options.map(user => [user.id, user])))

  if (canHaveMultipleValues) {
    return (
      <SelectMultipleUsers
        filterIndex={filterIndex}
        filterValue={filterValue as User[]}
        options={options}
        operator={operator}
        onChange={onChange}
      />
    )
  }

  return (
    <SelectSingleUser
      filterIndex={filterIndex}
      filterValue={filterValue as User}
      operator={operator}
      options={options}
      onChange={onChange}
      userMap={userMap.current}
    />
  )
}
